import React from "react";
import NavMenu from "../Nav/NavMenu";
import Footer from "../footer/Footer";
import EmptySlider from "../sliders/EmptySlider";
import defaultSliderGlobalImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import personalSavingAccontImage from "../../assets/static/personal/buy_electricity_1.png";

function StudentAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br>
      <br></br>
      <EmptySlider
        title="Student Account? We’ve got you covered."
        description="Kontriman provides multiple ways to assist you with your student account  through our help center, chat support, and email. Get the support you need, whenever and wherever you need it."
        imageUrl={defaultSliderGlobalImage}
      />
      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Text column */}
              <Col
                md={6}
                className="order-1 order-md-2 d-flex align-items-center"
              >
                <div>
                  <h1 className="custom_heading">Student Account</h1>
                  <p>
                    Our Student Account is specially designed to support
                    students with easy and affordable banking. Enjoy zero
                    monthly fees, convenient access, and tools to help you
                    manage your money while focusing on your studies.
                  </p>

                  <h5 className="mt-4">Features & Benefits</h5>
                  <ul>
                    <li>No monthly maintenance fees</li>
                    <li>Easy access through online and mobile banking</li>
                    <li>ATM withdrawals and debit card options</li>
                    <li>Financial tools and budgeting tips</li>
                  </ul>

                  <h5 className="mt-4">Eligibility</h5>
                  <ul>
                    <li>
                      Proof of student status (student ID or admission letter)
                    </li>
                    <li>Valid national ID or passport</li>
                    <li>Minimum age: 16 years</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">
                      Open Student Account
                    </Button>
                  </a>
                </div>
              </Col>

              {/* Image column */}
              <Col md={6} className="order-2 order-md-1">
                <img
                  src={personalSavingAccontImage}
                  alt="Student Account"
                  className="img-fluid"
                />
              </Col>
            </Row>
          </Container>
        </Container>
        <Footer></Footer>
      </div>
    </div>
  );
}

export default StudentAccount;
